export const StateReporting = [
	{
		stateCode: 'AL',
		label: 'Include in LEAPS Report',
	},
	//{
	//    stateCode: 'MI',
	//    label: 'Include in REP Report',
	//},
];
